/**
 * Carousel for the product "Delicious Ways to Use ..." recipes block
 * (snippets/ps-product-recipes.liquid).
 *
 * slidesPerView: 'auto' with fixed-width slides means the wide product column
 * shows the cards as a static row (3-up) and narrower screens turn into a
 * peeking carousel. watchOverflow disables the swiper + hides pagination when
 * every slide already fits, so desktop shows no dots. Idempotent.
 *
 * @author Maksym Mariukhnik
 */
(function () {
  // Top-level guard: if the asset is ever included more than once on a page, only
  // the first copy wires the listener (the per-element guard below is a second net).
  if (window.__psRecipesCarouselInit) return;
  window.__psRecipesCarouselInit = true;

  document.addEventListener('DOMContentLoaded', function () {
    if (!window.Swiper) return;

    document.querySelectorAll('.ps-product-recipes .recipes-carousel .swiper').forEach(function (el) {
      if (el.dataset.psSwiperInit) return;
      el.dataset.psSwiperInit = '1';

      // Mobile: the carousel is full-bleed to both screen edges (CSS margin-inline),
      // but the first and last slides are inset by the content gutter so the start
      // and end both have a matching edge while the middle cards bleed edge-to-edge.
      // The gutter is defined once as --ps-recipes-gutter (CSS) and read here so the
      // two never drift apart. Desktop (>=769px) uses no offsets.
      var section = el.closest('.ps-product-recipes');
      var gutter = parseFloat(getComputedStyle(section).getPropertyValue('--ps-recipes-gutter')) || 20;

      new Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: 18,
        watchOverflow: true,
        slidesOffsetBefore: gutter,
        slidesOffsetAfter: gutter,
        breakpoints: {
          769: { slidesOffsetBefore: 0, slidesOffsetAfter: 0 },
        },
        pagination: {
          el: el.querySelector('.swiper-pagination'),
          clickable: true,
        },
      });
    });
  });
})();
